// @flow
import FailureHandler from './FailureHandler';

export default FailureHandler;
